var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c("div", { staticClass: "content c-top" }, [
        _c("h2", [_vm._v("结算商品详情")]),
        _c(
          "div",
          { staticStyle: { display: "flex", "padding-bottom": "24px" } },
          _vm._l(_vm.records, function (item, index) {
            return _c("div", { key: index, staticClass: "record-item" }, [
              _c("div", { staticClass: "right" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _c("div", { staticClass: "price" }, [
                  _c("span", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v("￥"),
                  ]),
                  _vm._v(_vm._s(item.price) + " "),
                ]),
              ]),
            ])
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                staticClass: "search-form",
                attrs: { inline: true, model: _vm.searchForm, size: "small" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "结算来源", prop: "settlePlatformType" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择结算来源",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.settlePlatformType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "settlePlatformType", $$v)
                          },
                          expression: "searchForm.settlePlatformType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "平台", value: "1" },
                        }),
                        _c("el-option", {
                          attrs: { label: "五域", value: "2" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单编号", prop: "orderNo" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入订单编号" },
                      model: {
                        value: _vm.searchForm.orderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orderNo", $$v)
                        },
                        expression: "searchForm.orderNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "settleStatus" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择状态",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.settleStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "settleStatus", $$v)
                          },
                          expression: "searchForm.settleStatus",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "待结算", value: "1" },
                        }),
                        _c("el-option", {
                          attrs: { label: "已结算", value: "2" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "下单时间", prop: "orderTimeStart" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        "default-time": ["00:00:00", "23:59:59"],
                      },
                      model: {
                        value: _vm.value1,
                        callback: function ($$v) {
                          _vm.value1 = $$v
                        },
                        expression: "value1",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "content" }, [
        _vm._m(0),
        _c(
          "div",
          { attrs: { id: "base-list" } },
          [
            _c("lb-table", {
              directives: [
                {
                  name: "horizontal-scroll",
                  rawName: "v-horizontal-scroll",
                  value: "always",
                  expression: "'always'",
                },
              ],
              attrs: {
                column: _vm.columns,
                data: _vm.list,
                pagination: "",
                total: _vm.page.totalNum,
                layout: "total, sizes, prev, pager, next, jumper",
                "page-sizes": [5, 10, 20, 30, 50],
                "current-page": _vm.page.currentPage,
                "page-size": _vm.page.pageSize,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "selection-change": _vm.onMultipleSelection,
                "size-change": _vm.handleSizeChange,
                "p-current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("h3", [_vm._v("列表数据")]),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }